import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import Button from "@mui/material/Button";

const defaultTheme = createTheme({
  pallete: {
    primary: {
      main: "#008577",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "8px",
          padding: "10px 20px",
          fontSize: "1rem",
        },
        sizeSmall: { height: "40px", fontSize: "13px" },
        sizeMedium: { height: "56px" },
        sizeLarge: { height: "72px" },
        contained: {
          letterSpacing: "0.75px",
          padding: "0.5rem",
          backgroundColor: "#008577",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#008577",
          },
        },
        outlined: {
          letterSpacing: "0.75px",
          padding: "0.5rem",
          borderColor: "#008577",
          borderWidth: "2px",
          color: "#008577",
          "&:hover": {
            borderColor: "#008577",
          },
        },
      },
    },
  },
});

const MyButton = styled(Button)({
  boxShadow: "0 2px 4px rgba(0,0,0,0.2",
});

const ThemedButton = ({ children, customTheme, ...rest }) => {
  return (
    <ThemeProvider theme={customTheme || defaultTheme}>
      <MyButton {...rest}>{children}</MyButton>
    </ThemeProvider>
  );
};

export default ThemedButton;
